import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getMySubscriptionApi } from "../http/http";
import {
  clearAuthSession,
  getAuthToken,
  isAuthenticated,
  isSubscribedUser,
} from "../util/auth";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const token = getAuthToken();
    if (!token || !isSubscribedUser()) {
      setChecking(false);
      return;
    }

    getMySubscriptionApi(token)
      .then((result) => {
        setAllowed(Boolean(result?.data?.isSubscribed));
      })
      .catch((error) => {
        if ([401, 403].includes(error?.response?.status)) {
          clearAuthSession();
        }
        setAllowed(false);
      })
      .finally(() => setChecking(false));
  }, []);

  if (!isAuthenticated()) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  if (checking) return null;

  if (!allowed) {
    return (
      <Navigate
        to="/subscribe"
        replace
        state={{ from: location.pathname, reason: "subscription_required" }}
      />
    );
  }

  return children;
};

export default ProtectedRoute;
